import apiClient from '@utils/apiClient';

export const projectDetails = (payload) => {
  return apiClient.get(`${apiClient.Urls.projectDetails}`, payload, true);
};

export const leadershipFilterData = (payload) => {
  return apiClient.get(`${apiClient.Urls.leadershipFilterData}`, payload, true);
};

export const financialYears = (payload) => {
  return apiClient.get(`${apiClient.Urls.financialYears}`, payload, true);
};
